module.exports = __webpack_public_path__ + "img/image 1144@2x.8f40973e.png";